import { atom } from 'jotai'

// Stores the character ID of the active chat, or null when no chat is open.
// Plain atom (not atomWithStorage) — chat panel state resets on page reload.
export const activeChatCharacterAtom = atom(null)

// Derived read-only atom for convenience checks
export const isChatOpenAtom = atom((get) => get(activeChatCharacterAtom) !== null)
